<template>
  <div class="navbar-bottom">
    <ul class="navbar-group">
      <div v-for="item in localElements" v-bind:key="item.index">
        <div v-if="item.disabled" >
          <li class="navbar-element navbar-disabled" :style="item.styleObject">{{ item.label }}</li>
        </div>
        <div v-else>
          <li class="navbar-element navbar-enabled" :style="item.styleObject" @click="onClickButton(item.index)"
                    @mouseover="onMouseOverItem(item.index)"
                    @mouseleave="onMouseLeaveItem(item.index)">
                    {{ item.label }} 
                    <span v-if="item.submenu.length > 0" >
                    <i class="fa fa-caret-up"></i>
                    </span>
            <div v-if="item.showSubmenu" >

              <ul class="navbar-dropup-container">
              <div v-for="subitem in item.submenu" v-bind:key="subitem.index">
                <div v-if="subitem.hr == true" >
                  <hr>
                </div>
                <div v-else-if="subitem.disabled" >
                  <li class="navbar-dropup-element navbar-disabled">{{ subitem.label }}</li>
                </div>
                <div v-else>
                <li class="navbar-dropup-element navbar-enabled"
                        @click="onClickButton(subitem.index)">
                  <span v-if="subitem.checked == true"><i class="fa fa-check"></i></span>
                  {{ subitem.label }}
                </li>
                </div>
              </div>

              <!-- <li @mouseover="onMouseOverSubItem(4)" @mouseleave="onMouseLeaveSubItem(4)">SECOND</li> -->
            </ul>
            </div>
          </li>
        </div>
     
      </div>
      <div class="csi">
        <em>&copy; 2023 - Conceptual<br>Software, Inc.</em>
      </div>
    </ul>
  </div>
</template>

<script setup>

import { ref , watch } from 'vue'
import { useWindowSizeStore } from '../stores/windowSizeStore';
import { computed } from "@vue/reactivity"

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
const props = defineProps({
  elements : Array,
  trigger : Number
})

const emit = defineEmits(['toolbar-click'])

function onClickButton (index) {
  emit("toolbar-click",index)
}

function onMouseOverItem(index) {
  //console.log("mouse over parent ",index,localElements.value.length)
  if (index < localElements.value.length)
    localElements.value[index].showSubmenu = true

}

function onMouseLeaveItem(index) {
  //console.log("mouse leave parent ",index,localElements.value.length)
  if (index < localElements.value.length)
    localElements.value[index].showSubmenu = false
}

const trigger = computed({
  get() {
    return props.trigger
  },
  set(value) {
    //emit('subscribe:user', value)
  }
})

watch (trigger, () => {
  calcSpacing()
  })

const localElements = ref([])

calcSpacing()

function calcSpacing() {
  const csiWidth = 85
  const totalWidthForButtons = windowSizeRef.value.width - csiWidth

  var totalDesiredWidth = 0
  var totalMinWidth = 0

  // do we have enough space for everyone?

  localElements.value = []

  const elementCount = (props.elements === undefined) ? 0 : props.elements.length
  for (var i = 0; i < elementCount; i++) {

    const itemStringWidth = Math.ceil(props.elements[i].label.length * 7)

    const desiredWidth = (itemStringWidth <= 50) ? 100 : itemStringWidth + 50
    const minWidth = itemStringWidth + 50

    totalMinWidth += minWidth
    totalDesiredWidth += desiredWidth

    const submenu = (props.elements[i].submenu !== undefined) ? props.elements[i].submenu : []

    const oneElement = {
      index : props.elements[i].index,
      label : props.elements[i].label,
      disabled : props.elements[i].disabled,
      submenu : submenu,
      showSubmenu :  false,
      stringWidth : itemStringWidth,
      desiredWidth : desiredWidth,
      minWidth : minWidth,
      buttonIndex : i,
    }
    //console.log(oneElement)
    localElements.value.push(oneElement)
  
    //buttonInfoArray.push(oneButtonInfo)
  }


  // if total desired works then go with that
  // if total minimum works then go with that

  for (var i = 0; i < localElements.value.length; i++) {
    var useWidth = 0
      if (totalWidthForButtons >= totalDesiredWidth)
        useWidth = localElements.value[i].desiredWidth
      else
      if (totalWidthForButtons >= totalMinWidth)
        useWidth = localElements.value[i].minWidth
      else
        useWidth = Math.floor(localElements.value[i].minWidth * totalWidthForButtons / totalMinWidth)
      const styleObject = ref({
        width: useWidth + "px"
      })
      localElements.value[i].styleObject = styleObject
  }

  //console.log("################ local Elements",localElements.value)

}
watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** Toolbr -- window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** Toolbar new window size",windowSizeRef.value)
      calcSpacing()
    })

</script>

<style scoped>

.navbar-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height : 25px;
  overflow: hidden;

}
.navbar-group {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom : 5px;
  color: #fff;
  background-color: #4c6ca0;
  /*border-top-right-radius: 5px;
  border-top-left-radius: 5px;*/
  overflow:hidden;
}

.navbar-element {
  float: left;
  padding : 0px;
  display: block;
  text-decoration: none;
  text-align: center;
  overflow: hidden;
}

.navbar-disabled {
  color: #b7c4d9;
  pointer-events: none;
}

.navbar-enabled {
  cursor: pointer;

}

.navbar-enabled:hover {
  background-color: #3c5680;
  color: #f4f4f4;
  border: black 1px solid;
  border-radius: 5px;
}

.csi {
  text-align: right;
  font-size :8px;
  padding-right : 5px;
  pointer-events: none;
}

.navbar-dropup-container {
  bottom : 25px;
  width : 200px;
  position: fixed;
  list-style-type:none;
  background: #4c6ca0;
}

.navbar-dropup-element {
  margin : 5px;
  padding-left : 5px;
  padding-bottom : 10px;
  height : 30px;
  width : 190px;
  line-height: 1.4em;
  text-decoration: none;
  text-align: left;
}

.navbar-dropup-element:hover {
  border: black 1px solid;
  border-radius: 5px;
}

</style>